import { flattenValues } from '@uniformdev/canvas';
import { UniformLogo } from 'src/uniform/contenttypes/logo';

import { Connector } from '@/libraries/design/patterns/connector/src/connector';
import { CustomerQuote } from '@/libraries/design/patterns/connector/src/customer-quote-carousel';

export interface UniformConnectorProps {
	title: string;
	text: string;
	linkText?: string;
	linkHref?: string;
	customerQuotes: CustomerQuote[];
	mobileLogos: UniformLogo[];
	tabletLogos: UniformLogo[];
	desktopLogos: UniformLogo[];
	flattenData: boolean;
}

const UniformConnector = ({
	title,
	text,
	linkText,
	linkHref,
	customerQuotes,
	mobileLogos,
	tabletLogos,
	desktopLogos,
	flattenData = true,
}: UniformConnectorProps) => {
	if (flattenData) {
		customerQuotes = flattenValues(
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			customerQuotes as any,
		) as CustomerQuote[];
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		mobileLogos = flattenValues(mobileLogos as any) as UniformLogo[];
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		tabletLogos = flattenValues(tabletLogos as any) as UniformLogo[];
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		desktopLogos = flattenValues(desktopLogos as any) as UniformLogo[];
	}

	return (
		<Connector
			title={title}
			text={text}
			linkText={linkText}
			linkHref={linkHref}
			linkDataEventProps={{
				'data-product-key': 'uniform',
				'data-event': 'clicked',
				'data-event-component': 'linkButton',
				'data-event-container': 'connector',
			}}
			customerQuotes={customerQuotes}
			mobileLogos={mobileLogos}
			tabletLogos={tabletLogos}
			desktopLogos={desktopLogos}
		/>
	);
};

export default UniformConnector;
